import {
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_FETCH_DATA,
    PLUGIN_USE_COUNT,
    LAST_UNPAID_INVOICE,
    LAST_PAID_INVOICE,
    GET_TABLE_DATA,
} from './controlHubTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_FETCH_DATA:
            return {
                ...state,
                search_fetch_data: action.payload,
            }
        case GET_TABLE_DATA:
            return {
                ...state,
                table_data: action.payload,
            }
        case PLUGIN_USE_COUNT:
            return {
                ...state,
                plugin_use_count: action.payload,
            }
        case LAST_UNPAID_INVOICE:
            return {
                ...state,
                unpaid_payment: action.payload,
            }
        case LAST_PAID_INVOICE:
            return {
                ...state,
                paid_payment: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
